function getRunTimeConfig() {
  const browserWindow: any = window || {};
  const browserWindowEnv: any = browserWindow.__rxEnv__ || {};

  return browserWindowEnv;
}

function getProcessEnvConfig() {
  return process.env;
}

export default Object.freeze({
  ...getProcessEnvConfig(),
  ...getRunTimeConfig(),
});

export { getRunTimeConfig, getProcessEnvConfig };
